import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { ContentLoader } from '@frontend/design-system';
import { useCreateFormStepsStore } from '../provider';

const CreateFormLoader: FC = () => {
  const { t } = useTranslation('forms');
  const { isCreatingForm } = useCreateFormStepsStore(['isCreatingForm']);

  return <ContentLoader message={t('Creating form...')} show={isCreatingForm} />;
};

export default CreateFormLoader;
